"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockCallForwarderTarget__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "input1",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "input2",
                type: "uint256",
            },
        ],
        name: "nonpayableTargetFunction",
        outputs: [
            {
                internalType: "bytes",
                name: "output1",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "output2",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "input1",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "input2",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "msgValue",
                type: "uint256",
            },
        ],
        name: "payableTargetFunction",
        outputs: [
            {
                internalType: "bytes",
                name: "output1",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "output2",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "storage1",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "storage2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class MockCallForwarderTarget__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockCallForwarderTarget__factory = MockCallForwarderTarget__factory;
//# sourceMappingURL=MockCallForwarderTarget__factory.js.map